<template>
    <div class="register middle-box text-center loginscreen animated fadeInDown">
      <form @submit.prevent="regist">
      <div class="m-t">
      <!-- <web-view-terms /> -->
        <div class="login-panel">
            <div class="login-logo">
                <img alt="image" class="" src="static/img/logo_nav.png" />
            </div>
            <div class="form-group text-left">
                <label class="control-label">{{$t('idLabel')}}</label>
                <input type="text" v-model="email" class="form-control" :placeholder="$t('placeholderMailString')">
            </div>
            <div class="form-group text-left">
                <label class="control-label">{{$t('placeholderPasswordString')}}</label>
                <input type="password" v-model="password" class="form-control" :placeholder="$t('placeholderPasswordString')">
            </div>
        </div>
        <div class="login-btnset">
            <button type="submit" class="btn btn-success block m-b">{{$t('signUpString')}}</button>
            <router-link to="login" class="btn btn-primary block m-b">{{$t('loginString')}}</router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import WebViewTerms from '/_webview/WebViewTerms'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Register',
  mixedins: [validationMixin],
  data () {
    return {
      // msg: 'Let\'s Start 1on1navi!',
      email: '',
      password: ''
    }
  },
  validations: {
    email: { required },
    password: { required }
  },
  methods: {
    regist: function () {
      // console.log('login=' + email, password)
      const $swal = this.$swal
      const $t = this.$t
      if (!this.$v.email.required) {
        $swal({
          title: $t('noEmailStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.password.required) {
        $swal({
          title: $t('notPasswordString'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
      if (this.$v.email.required && this.$v.password.required) {
        this.$firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
          function (user) {
            console.log('RegistUser: Success', user.email)
            console.log('RegistUser: Password', user.password)
            // const userEmail = user.email
            this.$router.replace({
              name: 'ProfileRegist',
              params: { userEmail: user.email }
            })
          },
          function (error) {
            // Handle Errors here.
            var errorCode = error.code
            var errorMessage = error.message
            console.log('errorCode:', errorCode)
            console.log('errorMessage:', errorMessage)
            if (errorCode === 'auth/invalid-email') {
              $swal({
                title: $t('notEmailStr'),
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 3000
              })
            } else if (errorCode === 'auth/email-already-in-use') {
              $swal({
                title: $t('alReadyMessageString'),
                // title: 'すでに登録されているEmailです。',
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 3000
              })
            } else if (errorCode === 'auth/weak-password') {
              $swal({
                title: $t('leastCharMessageStringWeb'),
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 4000
              })
            }
          }
        )
      } else {
        // console.log('not enough')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Register.vue